
export default {
  allProducts: (state) => state.products,
  productsLoading: (state) => state.productsLoading
}
